/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowForm.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Master
 *
 * PURPOSE:
 * Workflow Create / Edit Form
 *
 * ARCHITECTURE:
 * - Bootstrap/AdminLTE
 * - Presentation Component
 * - No API Calls
 * - No Business Logic
 * - Controlled Component
 ******************************************************************************/

import React from "react";

export default function WorkflowForm({

    formData,

    errors = {},

    workflowTypes = [],

    departments = [],

    loading = false,

    saving = false,

    onChange,

    onSubmit,

    onCancel,

})

{
    console.log("WorkflowForm formData:", formData);
    const handleChange = (event) => {

        const {

            name,

            value,

            type,

            checked,

        } = event.target;

        onChange(

            name,

            type === "checkbox"
                ? checked
                : value

        );

    };

    return (

        <form
            onSubmit={onSubmit}
        >

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Workflow Code */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Workflow Code
                        <span className="text-danger">
                            *
                        </span>

                    </label>

                    <input

                        type="text"

                        name="code"

                        className={`form-control ${
                            errors.code
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.code || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.code && (

                        <div className="invalid-feedback">

                            {errors.code}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Workflow Name */}
                {/* ------------------------------------------------ */}

                <div className="col-md-8 mb-3">

                    <label className="form-label">

                        Workflow Name
                        <span className="text-danger">
                            *
                        </span>

                    </label>

                    <input

                        type="text"

                        name="name"

                        className={`form-control ${
                            errors.name
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.name || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.name && (

                        <div className="invalid-feedback">

                            {errors.name}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">
                            {/* ------------------------------------------------ */}
                {/* Workflow Type */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Workflow Type
                        <span className="text-danger">
                            *
                        </span>

                    </label>

                    <select

                        name="workflow_type"

                        className={`form-control ${
                            errors.workflow_type
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.workflow_type || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    >

                        <option value="">

                            Select Workflow Type

                        </option>

                        {workflowTypes.map((item) => (

                            <option

                                key={item.value}

                                value={item.value}

                            >

                                {item.label}

                            </option>

                        ))}

                    </select>

                    {errors.workflow_type && (

                        <div className="invalid-feedback">

                            {errors.workflow_type}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Department */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Department

                    </label>

                    <select

                        name="department_id"

                        className={`form-control ${
                            errors.department_id
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.department_id || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    >

                        <option value="">

                            Select Department

                        </option>

                        {departments.map((department) => (

                        <option

                            key={department.value}

                            value={department.value}

                        >

                            {department.label}

                        </option>

                    ))}

                    </select>

                    {errors.department_id && (

                        <div className="invalid-feedback">

                            {errors.department_id}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Version */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Version

                    </label>

                    <input

                        type="text"

                        name="version_no"

                        className="form-control"

                        value={
                            formData.version_no || ""
                        }

                        readOnly

                    />

                </div>

            </div>

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Effective From */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mb-3">

                    <label className="form-label">

                        Effective From

                    </label>

                    <input

                        type="date"

                        name="effective_from"

                        className={`form-control ${
                            errors.effective_from
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.effective_from || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.effective_from && (

                        <div className="invalid-feedback">

                            {errors.effective_from}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Effective To */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mb-3">

                    <label className="form-label">

                        Effective To

                    </label>

                    <input

                        type="date"

                        name="effective_to"

                        className={`form-control ${
                            errors.effective_to
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.effective_to || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.effective_to && (

                        <div className="invalid-feedback">

                            {errors.effective_to}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">
                            {/* ------------------------------------------------ */}
                {/* Description */}
                {/* ------------------------------------------------ */}

                <div className="col-md-12 mb-3">

                    <label className="form-label">

                        Description

                    </label>

                    <textarea

                        name="description"

                        rows="3"

                        className={`form-control ${
                            errors.description
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.description || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.description && (

                        <div className="invalid-feedback">

                            {errors.description}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Remarks */}
                {/* ------------------------------------------------ */}

                <div className="col-md-12 mb-3">

                    <label className="form-label">

                        Remarks

                    </label>

                    <textarea

                        name="remarks"

                        rows="3"

                        className={`form-control ${
                            errors.remarks
                                ? "is-invalid"
                                : ""
                        }`}

                        value={
                            formData.remarks || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.remarks && (

                        <div className="invalid-feedback">

                            {errors.remarks}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Default Workflow */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mb-3">

                    <div className="form-check mt-2">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="is_default"

                            name="is_default"

                            checked={
                                Boolean(
                                    formData.is_default
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="is_default"

                        >

                            Default Workflow

                        </label>

                    </div>

                </div>

                {/* ------------------------------------------------ */}
                {/* Active */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mb-3">

                    <div className="form-check mt-2">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="is_active"

                            name="is_active"

                            checked={
                                Boolean(
                                    formData.is_active
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="is_active"

                        >

                            Active

                        </label>

                    </div>

                </div>

            </div>

            <hr />

            {/* ------------------------------------------------ */}
            {/* ACTION BUTTONS */}
            {/* ------------------------------------------------ */}

            <div className="d-flex justify-content-end">

                <button

                    type="button"

                    className="btn btn-secondary me-2"

                    onClick={onCancel}

                    disabled={saving}

                >

                    Cancel

                </button>

                <button

                    type="submit"

                    className="btn btn-primary"

                    disabled={
                        loading || saving
                    }

                >

                    {saving
                        ? "Saving..."
                        : "Save Workflow"}

                </button>

            </div>
                    </form>

    );

}